const statusName: any = {
    overdue: 'Overdue',
    in_progress: 'In progress',
    upcoming: 'Upcoming',
    completed: 'Completed'
};

export default statusName;
